import { createContext, useContext } from 'react';

interface ToastContextType {
  showToast: (
    type: 'success' | 'error' | 'warning' | 'info',
    message: string,
    duration?: number
  ) => void;
}

export const ToastContext = createContext<ToastContextType | undefined>(
  undefined
);

export const useToast = () => {
  const context = useContext(ToastContext);
  if (!context) {
    throw new Error('useToast doit être utilisé dans un ToastProvider');
  }
  return context;
};
